// Import the functions you need from the SDKs you need
import {initializeApp} from 'firebase/app';

const firebaseConfig = {
    apiKey: 'AIzaSyBxU_EmnQCI6CSk1FiJE_oadb9ZPs7Q4yM',
    authDomain: 'tc15-f8944.firebaseapp.com',
    projectId: 'tc15-f8944',
    storageBucket: 'tc15-f8944.firebasestorage.app',
    messagingSenderId: '533529143231',
    appId: '1:533529143231:web:0e879741c0954e3336a30a',
    measurementId: 'G-7M16B2Z1XV',
};

// Initialize Firebase
initializeApp(firebaseConfig);

// Hero slider functionality
let currentSlide = 0;
const slides = document.querySelectorAll('.hero-slide');
const navButtons = document.querySelectorAll('.hero-nav button');
const SLIDE_INTERVAL = 7000; // 5 seconds

function changeSlide(index) {
    slides[currentSlide].classList.remove('active');
    navButtons[currentSlide].classList.remove('active');

    currentSlide = index;

    slides[currentSlide].classList.add('active');
    navButtons[currentSlide].classList.add('active');
}

function nextSlide() {
    const next = (currentSlide + 1) % slides.length;
    changeSlide(next);
}

// Auto-advance slides
setInterval(nextSlide, SLIDE_INTERVAL);

// Mobile menu functionality
const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
const navLinks = document.querySelector('.nav-links');

mobileMenuBtn.addEventListener('click', () => {
    navLinks.classList.toggle('active');
});

// Close mobile menu when clicking on a link
document.querySelectorAll('.nav-links a').forEach(link => {
    link.addEventListener('click', () => {
        navLinks.classList.remove('active');
    });
});

// Initialize map
async function initMap() {
    const location = {lat: 50.3704408, lng: 14.4616364};

    const {AdvancedMarkerElement, PinElement} = await google.maps.importLibrary('marker');

    const map = new google.maps.Map(document.getElementById('map'), {
        zoom: 16,
        center: location,
        mapId: 'TC15_MAP',
    });

    const pin = new PinElement({
        background: '#2c5f2d',
        borderColor: '#1a3a1b',
        glyphColor: 'white',
    });

    new AdvancedMarkerElement({
        map: map,
        position: location,
        title: 'Tennis Club Fifteen z. s.',
        content: pin.element,
    });
}

window.changeSlide = changeSlide;
window.initMap = initMap;

// Smooth scrolling for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchorElement => {
    anchorElement.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    });
});
